import React from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

class Navbar extends React.Component {
    logoutUser(){
        localStorage.clear();
    }

 
    render() {
        return (
            <div className="navbar">
                {/* div with logo */}
                <div className="imgContainer" style={{marginLeft:this.props.isExpanded?"285px":"100px"}}>
                {/* <h3 style= {{marginLeft: '50px',"font-family": 'Fantsy', color: 'rgb(255, 127, 14)' , 'font-size':' xx-large' ,'font-variant': 'proportional-nums','text-decoration': 'underline','textDecorationStyle': "double"}} >Rebate.ai</h3> */}
                                      <Link to="/"  className="btn btn-link"  > <img  height="35" src={process.env.PUBLIC_URL + '/IMARK Logo.png'} alt="img  " /></Link>
                </div>
                {/* div with options for help, logout */}
                <div className="navOptions">
                    <form className="form-inline">
                        <div className="navbar-form navbar-right">
                        <OverlayTrigger overlay={(<Tooltip id="callModal"> Contact Us</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                <a href="mailto: imarkplumbing.helpdesk@tredence.com,imark@tredence.com" className="btn btn-link"  data-placement="bottom" data-container="body"><i className="fas fa-envelope"></i></a>
                                     </OverlayTrigger>
                                        <OverlayTrigger overlay={(<Tooltip id="callModal"> Logout</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                
                                        <Link to="/logout" onClick={(e) => { this.logoutUser() }} className="btn btn-link" ><i className="fas fa-power-off"></i></Link>
                                       </OverlayTrigger>

                        
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default Navbar;